module.exports.CONSOLE_VERSION = '6.4.0.12'
module.exports.WI_CONSOLE_VERSION = '1.3.0.74'
